import React, { useState, useEffect } from 'react';

import { connectHits } from 'react-instantsearch-dom';

import { Map, MapMarker } from '/components/map/components';

const InternalProducerSearchResultsMap = ({ hits, activeHit }) => {
    const [googleMapsAPIStatus, setGoogleMapsAPIStatus] = useState('');
    const [map, setMap] = useState(null);
    const [api, setApi] = useState(null);

    const googleApiLoaded = (map, api) => {
        setMap(map);
        setApi(api);
        setGoogleMapsAPIStatus('loaded');
    };

    useEffect(() => {
        if (activeHit && activeHit._geoloc && activeHit._geoloc.lat && activeHit._geoloc.lng) {
            map.panTo(new window.google.maps.LatLng(
                activeHit._geoloc.lat,
                activeHit._geoloc.lng,
            ));
        }
    }, [activeHit]);

    return (
        <Map onGoogleApiLoaded={({ map, maps }) => { googleApiLoaded(map, maps); }}>
            {hits.filter(hit => Boolean(hit._geoloc && hit._geoloc.lat && hit._geoloc.lng)).map((hit) => (
                <MapMarker
                    title={hit.title}
                    producer={hit}
                    onClick={() => { window.setActiveHit(hit); }}
                    theme={hit.theme}
                    lat={hit._geoloc.lat}
                    lng={hit._geoloc.lng}
                    active={activeHit && activeHit.id === hit.id}
                    key={hit.id}
                />
            ))}
        </Map>
    );
};

const ProducerSearchResultsMap = connectHits(InternalProducerSearchResultsMap);

export { ProducerSearchResultsMap };
